'use client'

import TrackingScripts from "./components/TrackingScripts/TrackingScripts";
import React from "react";

export default function GlobalError({error, reset}) {
    return (
        <html>
        <TrackingScripts/>
        <body>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
        </body>
        </html>
    )
}